module.exports = __webpack_public_path__ + "static/media/skopei-360-only.61ded0c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/skopei-360-only.svg
// module id = 576
// module chunks = 14